import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import Box from '@material-ui/core/Box';
import { getProviderName } from "../utils/providersUtils";

const CustomNumberField = (props) => {
    const { source } = props;
    const record = useRecordContext(props);
    const sourceList = source.split(".");
    console.log(record);
    let finalRecord = record
    if (finalRecord != null) {
        if (sourceList.length > 1) {
            for (let item of sourceList) {
                console.log(item);
                if (finalRecord != null) {
                    finalRecord = finalRecord[item]
                }
            }
        } else {
            finalRecord = record[source]
        }
        console.log(finalRecord);
        return <Box sx={{  }}>
             {getProviderName(finalRecord)}
             </Box>;
    } else {
        return <span>-</span>;
    }
}

CustomNumberField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CustomNumberField;